import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { removeVote, saveVote } from '../api/votesAPI';
const initialState = {
  votes: {}
};
export const GenericFeedbackOptions = {
  incorrectAction: 'messageFeedback.option.incorrectAction',
  notRelevant: 'messageFeedback.option.notRelevant',
  incomplete: 'messageFeedback.option.incomplete',
  inaccurate: 'messageFeedback.option.inaccurate',
  other: 'messageFeedback.option.otherReason'
};
export const saveHappyVote = createAsyncThunk('votes/saveHappyVote', ({
  id
}) => saveVote(id, 1));
export const saveSadVote = createAsyncThunk('votes/saveSadVote', ({
  id,
  feedbackFreeform,
  feedbackGeneric
}) => saveVote(id, -1, feedbackGeneric === null || feedbackGeneric === void 0 ? void 0 : feedbackGeneric.toString(), feedbackFreeform));
export const removeMessageVote = createAsyncThunk('votes/removeMessageVote', ({
  id
}) => removeVote(id));
const votesSlice = createSlice({
  name: 'votes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // We only have to check for the existance of the vote entry in the pending
    // state because it creates an entry for the fulfilled and rejected states
    // to use.
    builder.addCase(saveHappyVote.pending, (state, action) => {
      if (state.votes[action.meta.arg.id]) {
        state.votes[action.meta.arg.id].value = 1;
      } else {
        state.votes[action.meta.arg.id] = {
          value: 1,
          persistedValue: undefined
        };
      }
    });
    builder.addCase(saveHappyVote.fulfilled, (state, action) => {
      state.votes[action.meta.arg.id].persistedValue = 1;
    });
    builder.addCase(saveHappyVote.rejected, (state, action) => {
      state.votes[action.meta.arg.id].value = state.votes[action.meta.arg.id].persistedValue;
    });
    builder.addCase(saveSadVote.pending, (state, action) => {
      if (state.votes[action.meta.arg.id]) {
        state.votes[action.meta.arg.id].value = -1;
        state.votes[action.meta.arg.id].feedbackFreeform = action.meta.arg.feedbackFreeform;
        state.votes[action.meta.arg.id].feedbackGeneric = action.meta.arg.feedbackGeneric;
      } else {
        state.votes[action.meta.arg.id] = {
          value: -1,
          persistedValue: undefined,
          feedbackFreeform: action.meta.arg.feedbackFreeform,
          feedbackGeneric: action.meta.arg.feedbackGeneric
        };
      }
    });
    builder.addCase(saveSadVote.fulfilled, (state, action) => {
      state.votes[action.meta.arg.id].persistedValue = -1;
    });
    builder.addCase(saveSadVote.rejected, (state, action) => {
      state.votes[action.meta.arg.id].value = state.votes[action.meta.arg.id].persistedValue;
    });
    builder.addCase(removeMessageVote.pending, (state, action) => {
      if (state.votes[action.meta.arg.id]) {
        state.votes[action.meta.arg.id].value = undefined;
      } else {
        state.votes[action.meta.arg.id] = {
          value: undefined,
          persistedValue: undefined
        };
      }
    });
    builder.addCase(removeMessageVote.fulfilled, (state, action) => {
      state.votes[action.meta.arg.id].persistedValue = undefined;
    });
    builder.addCase(removeMessageVote.rejected, (state, action) => {
      state.votes[action.meta.arg.id].value = state.votes[action.meta.arg.id].persistedValue;
    });
  }
});
export default votesSlice.reducer;